<template>
  <div>
    <section id="hero2" v-if="true">
      <Slick ref="slick" :options="slickOptions" class="slick-item">
        <article style="background:#FFFFEA;">
          <div class="main-wraper">
            <a href="#">
              <img src="/static/renew_img/topbnr.png">
            </a>
          </div>
        </article>
      </Slick>
    </section>

    <section id="yagish_service" class="yagish_service">
      <div class="content-wrapper">
        <h2><span>yagishでできること</span></h2>
        <div class="service_list">
          <div class="service_item">
            <div class="service_item_ti">
              <img src="/static/renew_img/yagish_service01.svg" alt="就活生向け">
              <h5>就活生向け</h5>
            </div>
            <div class="service_item_contents">
              <p class="service_item_txt">大学専用の履歴書のほか、インターンシップで使える履歴書もあります。書類を郵送したい場合に送付状もご用意！</p>
              <button class="service_item_btn"
                onclick="location.href='/format/rirekisho_gardenbaika'"><span>専用履歴書</span><span>></span></button>
              <button class="service_item_btn"
                onclick="location.href='/format/letter'"><span>送付状</span><span>></span></button>
            </div>
          </div>
          <div class="service_item">
            <div class="service_item_ti">
              <img src="/static/renew_img/yagish_service03.svg" alt="おすすめ">
              <h5>おすすめ</h5>
            </div>
            <div class="service_item_contents">
              <p class="service_item_link">コンビニプリント</p>
              <p class="service_item_lead">ボタン1つでコンビニ印刷に登録！</p>

              <!-- <a href="" class="service_item_link" target="_blank">ヤギオファー ></a>
                      <p class="service_item_lead">就活のオファーが届くサービス</p> -->

            </div>
          </div>
        </div>
        <div class="service_login" v-if="!$firebase.isAuthenticated">
          <p class="service_login_txt">＼マイページで履歴が見れるよ！／</p>
          <button class="service_login_btn" onclick="location.href='/login'">ログインする</button>
        </div>
      </div>
      <br>
      <br>
      <br>
    </section>
    <section id="navlist">
      <div class="content-wrapper">
        <h2><span>作成できる書類一覧</span></h2>
        <article class="flex-box">
          <div class="flex-item" :key="f.id" v-for="f in $site.formatsIndex" :class="recentEditClass(f)"
            style="line-height:1;">
            <p class="tag" v-if="f.id === 'rirekisho_job_change'">おすすめ</p>
            <div class="img_base">
              <img :src="f.thumbnail" :alt="f.title + 'テンプレート'">
            </div>
            <p class="title">{{ f.title }}</p>
            <ul>
              <li>{{ f.newdetail1 }}</li>
              <li v-if="f.newdetail2 != ''">{{ f.newdetail2 }}</li>
              <li>{{ f.newdetail3 }}</li>
            </ul>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }"
              v-if="f.id != 'letter' && f.id != 'shokumukeirekisho'">この履歴書で作る
            </router-link>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }" style="background-color:orange"
              v-else-if="f.id != 'shokumukeirekisho'">送付状を作る
            </router-link>
            <router-link :to="{ name: 'formatDetail', params: { formatId: f.id } }" v-else
              style="background-color:rgb(15, 153, 52)">職務経歴書を作る
            </router-link>
          </div>
        </article>
      </div>
    </section>
    <section id="about">
      <div class="content-wrapper">
        <h2><span>ヤギッシュとは？</span></h2>
        <img src="/static/renew_img/about_pc.png" alt="PC、スマホ、タブレットで無料で履歴書が作れちゃうよ！" class="pc">
        <img src="/static/renew_img/about_sp.png" alt="PC、スマホ、タブレットで無料で履歴書が作れちゃうよ！" class="sp">
        <p>
          yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。<br>
          転職用、新卒用、アルバイト用など多数のテンプレートを用意。<br>
          外出先でも、必要なときにいつでも履歴書を作成でき、作成した履歴書はダウンロードやコンビニ印刷も可能！
        </p>
      </div>
    </section>
    <section id="howto">
      <div class="content-wrapper">
        <h2><span>ヤギッシュの使い方</span></h2>
        <img src="/static/renew_img/howto_pc.png" alt="3ステップで入力〜印刷までブラウザ完結" class="pc step">
        <img src="/static/renew_img/howto_sp.png" alt="3ステップで入力〜印刷までブラウザ完結" class="sp step">
        <img src="/static/renew_img/flow_pc.png" class="pc flow" alt="1.履歴書選択、2.履歴書入力 3.コンビニ印刷かpdfダウンロード">
        <img src="/static/renew_img/flow_sp.png" class="sp flow" alt="1.履歴書選択、2.履歴書入力 3.コンビニ印刷かpdfダウンロード">
        <a class="btn_sub" href="/info">もっと詳しくみる<img src="/static/renew_img/icon_link.svg" alt="ヤギッシュの使い方を詳しく見る"></a>
        <article v-if="!$firebase.isAuthenticated">
          <p class="title">ログインすると<br><span>さらに</span>便利に使える！</p>
          <img src="/static/renew_img/login-merit.png" alt="1.履歴書のバックアップ 2.コンビニ印刷が可能に">
          <p>※対応しているコンビニは、セブンイレブン・ファミリーマート・ローソンなど全国58,000店舗以上で、印刷は有料となります。</p>
          <div class="btn_wrapper">
            <a class="btn_cta " href="/login">ログインする<img src="/static/renew_img/icon_login.svg" alt="ログイン"></a>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css?date=20230222";
</style>

<style scoped>
.yagish_service {
  margin-bottom: -40px;
}

.service_list {
  display: flex;
  text-align: left;
  justify-content: center;
}

.service_item {
  width: calc(100% / 3);
  border: 2px solid #004D40;
  border-radius: 10px;
  margin: 5px;
}

.service_item_ti {
  display: flex;
  justify-content: center;
  padding: 8px;
  background: #004D40;
  border-radius: 8px 8px 0 0;
  color: #fff;
}

.service_item_ti h5 {
  padding-left: 10px;
}

.service_item_btn {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 20px;
  margin-top: 10px;
  background: #E3165C;
  color: #fff;
  font-weight: bold;
  border-radius: 50px;
}

.service_item_contents {
  padding: 15px;
}

a.service_item_link,
.service_item_link {
  color: #E3165C;
  font-weight: bold;
}

.service_item_lead {
  font-size: 0.8rem;
  margin-bottom: 5px;
}

.service_login {
  text-align: center;
  margin-top: 20px;
}

.service_login_txt {
  color: #004D40;
  font-weight: bold;
  font-size: 0.8rem;
}

.service_login_btn {
  color: #fff;
  background: #E3165C;
  padding: 10px 25px;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 50px;
}

@media screen and (max-width: 480px) {
  .service_list {
    flex-wrap: wrap;
  }

  .service_item {
    width: 100%;
  }
}
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick
  },
  data: function () {
    return {
      is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 400
      }
    }
  },
  methods: {
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    }
  },
  created: function () {
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  }
}
</script>
